import React from 'react'
import { Accordion } from 'react-bootstrap'
import { formatNumbers, formatSmartDecimal, getBackgroundColor, getTokenSymbol, isStableTokenSymbol } from '../../utils/helpers';
import { useTranslation } from 'react-i18next';

const MyPosition = ({ buyingOptionValues, investedAmount, theme, tokenToDisplay, tokenSymbol, tokenPriceToUsdt, winnerOptionId, isClaimWindowOpen, claimNotDisputed, winnerData }) => {
    const { t } = useTranslation()

    return (
        <>
            <Accordion className="myposition-box">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{t("My Position")}</Accordion.Header>
                    <Accordion.Body>
                        <div className="upper-position">
                            <div className="text">
                                <p>{t("Total investment")}</p>
                                <div className="twice-text">
                                    <h6>{investedAmount ? Number(investedAmount).toFixed(2) : 0} {tokenToDisplay}</h6>
                                    {
                                        !isStableTokenSymbol(tokenSymbol) && (
                                            <h5>${formatSmartDecimal(investedAmount * tokenPriceToUsdt)}</h5>
                                        )
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="bottom-position">
                            {buyingOptionValues.map((item, index) => {
                                const backgroundColor = getBackgroundColor(index, theme, buyingOptionValues?.length)
                                return (
                                    <div className={`single-textt${isClaimWindowOpen && !claimNotDisputed && item.optionId === winnerData?.winnerId ? ' correct-outcome' : ''}`} key={index}>
                                        <h6>
                                            <span style={{ backgroundColor: backgroundColor }}></span>
                                            {item?.optionName}
                                        </h6>
                                        <div className="twice-text">
                                            <p>
                                                {item?.availableBuyingShares}{" "} Shares
                                            </p>
                                            <h5>{getTokenSymbol(tokenSymbol)}{formatNumbers(+item?.PriceConversion)}</h5>
                                        </div>
                                    </div>

                                )
                            })}
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    )
}

export default MyPosition
